import AccountInformationScreen from './AccountInformationScreen';
import SubscriptionScreen from './SubscriptionScreen';
import SupportScreen from './SupportScreen';
import AccountScreen from './AccountScreen';
import AccountDeletionConfirmationScreen from './AccountDeletionConfirmationScreen';
import PreferencesScreenContent from './PreferencesScreen';
import RedirectScreen from './RedirectScreen';
import wrapInTabContentContainer from '../../../AppNavigator/TabNavigation/wrapInTabContentContainer';

const screens = {
    AccountInformationScreen: wrapInTabContentContainer(AccountInformationScreen),
    SubscriptionScreen: wrapInTabContentContainer(SubscriptionScreen),
    SupportScreen: wrapInTabContentContainer(SupportScreen),
    AccountScreen: wrapInTabContentContainer(AccountScreen),
    AccountDeletionConfirmationScreen: wrapInTabContentContainer(AccountDeletionConfirmationScreen),
    PreferencesScreen: wrapInTabContentContainer(PreferencesScreenContent),
    RedirectScreen: wrapInTabContentContainer(RedirectScreen),
};

export { screens };
